import { defineStore } from 'pinia'
import type { IApiInstance } from '~/plugins/api'

export const useObservationCMSStore = defineStore('observationCMS', {
  state: () => ({
    items: [] as any[],
  }),
  getters: {
    getObservationCategory: (state) => () => {
      return [...new Set(state.items.map((e: any) => e.category))]
    },
    getNotFound: (state) => (res: any) => {
      return {
        code: res.code,
        type: 'float',
        precision: 5,
        range_min: 0,
        range_max: 50000000,
        translations: [
          {
            observations_code: res.code,
            languages_id: 'fr-FR',
            name: res.code + ' Not found in CMS',
            short_name: res.code + ' Not found in CMS',
          },
        ],
        unit: {
          unit: res.unit,
          alternatives: [],
        },
        unit_alternates: [],
      }
    },
  },
  actions: {
    clearObservationItems() {
      this.items = []
    },
    async load() {
      const { ENVIRONMENT } = useEnvironment()
      const api: IApiInstance = useNuxtApp().$api as IApiInstance
      const monitorFilterEnv: any = {
        production: ['production'],
        staging: ['production', 'staging'],
        develop: ['production', 'staging', 'develop'],
      }
      const observationCMS = await api.cms.getAll({
        collection: 'observations',
        query: `fields[]=*&limit=10000&fields[]=translations.*&fields[]=unit_alternates.units_unit&fields[]=unit.unit&fields[]=unit.alternatives&filter[status][_in]=${monitorFilterEnv[ENVIRONMENT]}`,
      })

      observationCMS.data.forEach((element: any) => {
        element.unit_alternates = element.unit_alternates.map((d: any) => d.units_unit)
      })

      this.items = observationCMS.data
    },
    clear() {
      this.$reset()
    },
  },
})
